import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import Colors from '../../constants/Colors';
import { AntDesign } from '@expo/vector-icons';
import { containerDimensions } from '../../utils/Functions';

export default function ProjectPhoto({ ...props }) {

  return (
    <View style={[styles.container, containerDimensions(4, props.which)]}>
      <Image source={{ uri: props.uri }} style={styles.img} />
      {props.remove && <TouchableOpacity style={styles.removeContainer} onPress={() => props.remove(props.uri)} activeOpacity={0.5} >
        <AntDesign name="closesquareo" size={24} color='white' style={styles.removeIcon2} />
        <AntDesign name="closesquare" size={24} color={Colors.red} style={styles.removeIcon2} />
      </TouchableOpacity>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 10,
    // borderRadius: 10,
    // borderStyle: 'solid',
    // borderWidth: 2,
    // borderColor: Colors.lightBlue,
    // overflow: 'hidden',
    // width: '25%',
    // marginRight: '1%',
  },
  img: {
    width: '100%',
    height: 80,
    borderRadius: 10,
  },
  removeContainer: {
    position: 'absolute',
    top: -1.5,
    right: -1.5,
    // borderTopRightRadius: 10,
  },
  removeIcon2: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
});

